import "./index.css";

import { About } from "./components/About";
import { Contact } from "./components/Contact";
import { Education } from "./components/Education";
import { Experience } from "./components/Experience";
import { GlassField } from "./components/GlassField";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { Projects } from "./components/Projects";
import { Skills } from "./components/Skills";
import { profile } from "./data";

function Footer() {
  return (
    <footer className="relative mt-10">
      <div className="mx-auto max-w-6xl px-6 pb-16 sm:px-8">
        <div className="flex flex-col items-start justify-between gap-6 border-t border-white/[0.08] pt-8 sm:flex-row sm:items-center">
          <div className="flex items-center gap-3">
            <span className="glass grid h-9 w-9 place-items-center rounded-[13px] text-display text-[0.8rem] font-semibold text-porcelain">
              {profile.monogram}
            </span>
            <p className="text-[0.85rem] text-mist">
              {profile.name} — <span className="text-faint">portfolio, {new Date().getFullYear()}</span>
            </p>
          </div>

          <div className="flex items-center gap-6 text-[0.82rem]">
            <a href="#top" className="link-underline text-mist transition-colors hover:text-porcelain">
              Back to top
            </a>
            <a
              href={profile.linkedin}
              target="_blank"
              rel="noreferrer"
              className="link-underline text-mist transition-colors hover:text-porcelain"
            >
              LinkedIn
            </a>
            <a
              href={`mailto:${profile.email}`}
              className="link-underline text-mist transition-colors hover:text-porcelain"
            >
              Email
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export function App() {
  return (
    <div className="grain relative">
      <a
        href="#work"
        className="sr-only rounded-full bg-porcelain px-4 py-2 text-sm font-semibold text-midnight focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-[70]"
      >
        Skip to content
      </a>

      <GlassField />
      <Header />

      <main id="main" className="mx-auto max-w-6xl px-6 sm:px-8">
        <Hero />
        <About />
        <Experience />
        <Projects />
        <Skills />
        <Education />
        <Contact />
      </main>

      <Footer />
    </div>
  );
}

export default App;
